import fetchJSON from '../fetchJSON'

export interface AuthStatusResponse {
  isSessionCookiePresent: boolean
}

export const defaultState: AuthStatusResponse = {
  isSessionCookiePresent: false
}

async function fetchAuthStatus(hostUrl = '') {

  try {

    const { data } = await fetchJSON<AuthStatusResponse>('fetchAuthStatus', `${hostUrl || process.env.HOST}/webcast/api/auth/status`, { includeCredentials: true })

    return data

  } catch (error) {

    return defaultState

  }

}

export default fetchAuthStatus
